import { render, staticRenderFns } from "./GoPro.vue?vue&type=template&id=378d664f&scoped=true"
import script from "./GoPro.vue?vue&type=script&lang=js"
export * from "./GoPro.vue?vue&type=script&lang=js"
import style0 from "./GoPro.vue?vue&type=style&index=0&id=378d664f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d664f",
  null
  
)

export default component.exports